import type { SearchResult } from '@/queries/listingSearchQuery'

const PROMOTION_TYPE_LOW_BIDDER = 'low-bidder' as const

export const getPromotedAnalyticsFields = (
  listing: Pick<SearchResult, 'isPromoted'>
): {
  is_promoted: boolean
  promotion_type: typeof PROMOTION_TYPE_LOW_BIDDER | null
} => ({
  is_promoted: !!listing.isPromoted,
  promotion_type: listing.isPromoted ? PROMOTION_TYPE_LOW_BIDDER : null,
})
